import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofPopup } from './components/SocialProofPopup';
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const AgitationSection = lazy(() => import('./components/AgitationSection').then(m => ({
  default: m.AgitationSection
})));
const CauseSection = lazy(() => import('./components/CauseSection').then(m => ({
  default: m.CauseSection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const IncludesSection = lazy(() => import('./components/IncludesSection').then(m => ({
  default: m.IncludesSection
})));
const ValueSection = lazy(() => import('./components/ValueSection').then(m => ({
  default: m.ValueSection
})));
const PurchaseSection = lazy(() => import('./components/PurchaseSection').then(m => ({
  default: m.PurchaseSection
})));
const ForWhomSection = lazy(() => import('./components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const EmotionalClose = lazy(() => import('./components/EmotionalClose').then(m => ({
  default: m.EmotionalClose
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
export function App() {
  useEffect(() => {
    // Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n = (f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    }) as any;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1272607964501807');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-warm-white font-sans selection:bg-sky/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <PainSection data-id="element-3" />
        <AgitationSection data-id="element-4" />
        <CauseSection data-id="element-5" />
        <MethodSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <IncludesSection data-id="element-8" />
        <ValueSection data-id="element-9" />
        <PurchaseSection data-id="element-10" />
        <ForWhomSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <EmotionalClose data-id="element-13" />

        {/* Final CTA duplicate of Purchase Section is handled by scrolling to #compra from all buttons */}
        <div className="bg-navy-dark py-16 text-center px-4" data-id="element-14">
          <h2 className="text-3xl font-bold text-white mb-8" data-id="element-15">
            ¿Lista para empezar esta misma noche?
          </h2>
          <a href="#compra" className="inline-block bg-gold hover:bg-gold-light text-navy text-xl font-bold py-4 px-10 rounded-full shadow-premium transition-all transform hover:scale-105" data-id="element-16">
            VER OPCIONES DE ACCESO
          </a>
        </div>

        <FooterSection data-id="element-17" />
      </Suspense>
      <SocialProofPopup data-id="element-18" />
    </div>;
}